export const BRAND_NAME = 'TitosExch';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'titosexch.com';
export const PROVIDER_ID = 'BetFair';
